import React from "react";
import { FaIcon } from "../../../lib/FaIcon";
import { useScrollPosition } from "react-use-scroll-position";
import { DelayedRender } from "./DelayedRender";

export const ScrollToTopButton = ({ chatbotIcon }) => {
  useScrollPosition();
  const isVisible = window.pageYOffset > 0;

  return (
    <div
      style={{
        position: "fixed",
        right: 10,
        bottom: 10,
        display: "flex",
        flexDirection: "column-reverse",
        alignItems: "flex-end",
        zIndex: 5,
        pointerEvents: "none",
      }}
    >
      {isVisible && (
        <div style={{ pointerEvents: "auto", marginBottom: 50 }}>
          <DelayedRender delay={1000}>
            <ScrollUpButton />
          </DelayedRender>
        </div>
      )}
      <div style={{ pointerEvents: "auto" }}>
        {chatbotIcon}
      </div>
    </div>
  );
};

export function ScrollUpButton() {
  return (
    <div className="position-fixed" style={{ right: 10, bottom: 10 }}>
      <FaIcon icon="fas fa-chevron-circle-up fa-3x text-gray hover-primary" onClick={() => window.scrollTo(0, 0)} />
    </div>
  );
}
